import { bannersApi } from '@/slice/banners';
import { cartApi } from '@/slice/cartApi';
import cartReducer from '@/slice/cartSlice';
import celebritiesReducer, { celebritiesApi } from '@/slice/celebrities';
import confirmReducer from '@/slice/confirm';
import { couponApi } from '@/slice/couponApi';
import errorReducer from '@/slice/error';
import exchangeRateReducer from '@/slice/exchangeRateSlice';
import { inboxApi } from '@/slice/inbox';
import { inquiryApi } from '@/slice/inquiryApi';
import loadingReducer from '@/slice/loadingSlice';
import myPayHistoryReducer from '@/slice/myPayHistory';
import { myPayHistoryApi } from '@/slice/myPayHistoryApi';
import { shippingCompanyApi } from '@/slice/shippingCompany';
import shopCardReducer from '@/slice/shopCartSlice';
import shopReducer from '@/slice/shopSlice';
import signUpUserReducer from '@/slice/signUpUserSlice';
import termsReducer from '@/slice/terms';
import tossPayReducer from '@/slice/tossPay';
import { configureStore } from '@reduxjs/toolkit';

export const store = configureStore({
  reducer: {
    confirm: confirmReducer,
    error: errorReducer,
    exchangeRate: exchangeRateReducer,
    loading: loadingReducer,
    shopCart: shopCardReducer,
    shop: shopReducer,
    signUpUser: signUpUserReducer,
    myPayHistory: myPayHistoryReducer,
    terms: termsReducer,
    [inboxApi.reducerPath]: inboxApi.reducer,
    [bannersApi.reducerPath]: bannersApi.reducer,
    tossPay: tossPayReducer,
    [celebritiesApi.reducerPath]: celebritiesApi.reducer,
    celebrities: celebritiesReducer,
    [shippingCompanyApi.reducerPath]: shippingCompanyApi.reducer,
    [cartApi.reducerPath]: cartApi.reducer,
    [myPayHistoryApi.reducerPath]: myPayHistoryApi.reducer,
    cart: cartReducer,
    [couponApi.reducerPath]: couponApi.reducer,
    [inquiryApi.reducerPath]: inquiryApi.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(
      inboxApi.middleware,
      bannersApi.middleware,
      celebritiesApi.middleware,
      shippingCompanyApi.middleware,
      myPayHistoryApi.middleware,
      cartApi.middleware,
      couponApi.middleware,
      inquiryApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
